import React from 'react'

import CustomHelmet from '../../components/CustomHelmet'
import Hero from '../../components/ProgramOverview/Hero'
import Apply from '../../components/Apply'
import Helmet from 'react-helmet'
import Fellows from '../../components/Fellows'
import Row from '../../components/Shared/Row'
import Column from '../../components/Shared/Column'
import BioCard from '../../components/BioCard'
import BioTray from '../../components/BioTray'


class TheSchedule extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeProfile: null,
        }
    }


    render() {
        return (
          <section className="bg-grey">
              <div className="academy-schedule block standard-spacing">
                <h3 className="h1 large">Explore a typical week</h3>
                <p className="schedule-intro">Global Citizen Academy offers an engaging blend of interactive online learning, discussions with leading innovators, real-world projects, and peer collaboration.</p>
                <p className="alt">Explore the sample schedule below to get a taste of the exploration, community, and growth that’s possible with Global Citizen Academy. To accommodate different time zones and schedules, there will be multiple sections for each course. Your schedule may not look exactly like the sample below, but we'll do our absolute best to make sure every student can join a session that works for them!</p>
                <div className="grid-outer grid-rows">
                    <div className="grid-5 bg-green">
                        <div className="empty"></div>
                        <div>MONDAY</div>
                        <div>TUESDAY</div>
                        <div>WEDNESDAY</div>
                        <div>THURSDAY</div>
                    </div>
                    <div className="grid-5">
                        <div className="bg-dark card time-card">MORNING</div>
                        <div className="bg-white card schedule-card">
                            <h3>Leadership As A Practice: Seminar</h3>
                            <em>19 students / 90 minutes</em>
                            <p>Gain clarity, confidence and concrete skills to connect the values that drive you with the change you want to see in the world.</p>
                        </div>
                        <div className="bg-white card schedule-card">
                            <h3>Speaker Series: Leadership in Action </h3>
                            <em>60 minutes</em>
                            <p>Join weekly conversations with today’s most innovative leaders.</p>
                        </div>
                        <div className="bg-white card schedule-card">
                            <h3>Leadership As A Practice: Learning Group</h3>
                            <em>6-8 students / 60 minutes</em>
                            <p>Discuss the concepts from the seminar in a supportive small group setting with peers from across the globe.</p>
                        </div>
                        <div className="bg-white card schedule-card">
                            <h3>Leadership As A Practice</h3>
                            <em>6-8 students / 60 minutes</em>
                            <p>Discuss the concepts from the seminar in a supportive small group setting with peers from across the globe.</p>
                        </div>
                    </div>
                    <div className="grid-2 afternoon">
                        <div className="bg-dark card time-card">AFTERNOON</div>
                        <div className="bg-white card schedule-card">
                            <h3>Volunteer with our Impact Partners</h3>
                            <p>Put theory into practice by volunteering with one of our impact partners working at the forefront of global challenges. [Optional]</p>
                            <br />
                            <h3>Personalized Mentorship</h3>
                            <p>Connect one-on-one with your personal mentor to set leadership goals and receive guidance on topics spanning college, career, and personal growth.</p>
                        </div>
                    </div>
                    <div className="grid-2 evening">
                        <div className="bg-dark card time-card">EVENING</div>
                        <div className="bg-white card schedule-card">
                            <h3>Reflect & Prep</h3>
                            <p>Prepare for class with thought-provoking podcasts, TEDtalks, readings, and prompts for reflection.</p>
                        </div>
                    </div>
                    <div className="grid-2 evening">
                        <div className="bg-dark card time-card"></div>
                        <div className="bg-white card schedule-card">
                            <h3>Student-Led Clubs & Events</h3>
                            <p>Connect with classmates across the world on the Academy’s Discord server which is overflowing with student-led clubs, discussions, events, resources, and collaborative projects.</p>
                        </div>
                    </div>
                </div>
              </div>
             </section>
    )
  }
}

export default TheSchedule



// WEBPACK FOOTER //
// ./src/components/TheSchedule/index.js